// React-Query key hierarchy for the SDK. Apps using TanStack Query can invoke
// `queryClient.invalidateQueries(planSdkKeys.current())` from anywhere to
// force a re-fetch (e.g. after a successful checkout, in BillingSuccessPage).

export const planSdkKeys = {
  all: () => ['plan-sdk'] as const,
  catalog: () => ['plan-sdk', 'catalog'] as const,
  current: () => ['plan-sdk', 'current'] as const,
  invoices: () => ['plan-sdk', 'invoices'] as const,
  checkoutConfirm: (sessionId: string) =>
    ['plan-sdk', 'checkout', sessionId] as const,
};
